<template>
  <div id="app">
    <Nav :pt="isIndex" />
    <div class="pageMain">
      <div class="p20">
        <h3 class="viewTitle">{{detailInfo.title}}</h3>
        <div class="viewAuthor">2020.07.01<br>苏州民族管弦乐团 </div>
        <div class="viewMainBg mt20" v-if="detailInfo.content" >
          <div class="viewMain">
            <div v-html="detailInfo.content"></div>
          </div>
        </div>
      </div>
      <Footer /> 
    </div>
    
  </div>
</template>

<style scoped>
 
</style>
<script>
import Nav from '@/components/nav.vue'
import Footer from '@/components/footer.vue'
export default { 
  name: 'App',
  components: {
    Nav,
    Footer
  },
  beforeRouteEnter(to, from, next) {
    console.log(to.params.id)
    window.scrollTo(0,0);

    next((vm) => {
      vm.id = to.params.id 
      vm.getNewsDetail()
    });
  },
  data () {
    return {
      isIndex: false,
      id: '',
      detailInfo:{},
    }
  },
  computed: {
      
  },
  created() {
     
  },
  methods:{
    // 获取演出列表
    getNewsDetail() {
      this.$ajax.get("/cms/api/dnewsdetail", {
        id: this.id
      }).then((res) => {
        if (res.code == "200") {
          // this.showlist = res.data;
          console.log('tag', res)
          this.detailInfo = res
        }
      });
    },
  },
}
</script>

